import { render, staticRenderFns } from "./TramitesAdministrativosTabContent.vue?vue&type=template&id=2ee657db&scoped=true"
import script from "./TramitesAdministrativosTabContent.vue?vue&type=script&lang=js"
export * from "./TramitesAdministrativosTabContent.vue?vue&type=script&lang=js"
import style0 from "./TramitesAdministrativosTabContent.vue?vue&type=style&index=0&id=2ee657db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee657db",
  null
  
)

export default component.exports